<script setup>
import { computed } from 'vue';
import { FEATURE_ICONS } from './featureIcons';

const props = defineProps({
    name: { type: String, default: 'star' },
});

const shapes = computed(() => FEATURE_ICONS[props.name] || FEATURE_ICONS.star);
</script>

<template>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"
         stroke-linecap="round" stroke-linejoin="round" class="tiq-feature-icon-svg" aria-hidden="true">
        <template v-for="(s, i) in shapes" :key="i">
            <path v-if="s.d" :d="s.d" />
            <circle v-else-if="s.circle"
                    :cx="s.circle.cx" :cy="s.circle.cy" :r="s.circle.r"
                    :fill="s.circle.fill ? 'currentColor' : 'none'" />
            <ellipse v-else-if="s.ellipse"
                     :cx="s.ellipse.cx" :cy="s.ellipse.cy"
                     :rx="s.ellipse.rx" :ry="s.ellipse.ry" />
            <rect v-else-if="s.rect"
                  :x="s.rect.x" :y="s.rect.y" :width="s.rect.w" :height="s.rect.h" :rx="s.rect.rx" />
        </template>
    </svg>
</template>

<style scoped>
.tiq-feature-icon-svg { width: 100%; height: 100%; display: block; }
</style>
